import { Buffer } from "buffer"
import React from "react"
import ReactDOM from "react-dom/client"
import "../styles/content-wide.scss"
import "../styles/main.scss"
import App from "./App"

// Polyfill Buffer for front-matter
window.Buffer = Buffer

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
)
